<template>
  <div class="pause modal-2" v-if="getModalPause">
    <div class="modal-content-my">
      <form class="form-modal">
        <div class="modal-head">
          <h3 class="title-text">Pausas</h3>
          <span @click="btnClose" class="closeBtn">&times;</span>
        </div>

        <div
          class="opcoes"
          v-for="pause in getPauses"
          :key="pause.id"
          @click="clickPause(pause.id, pause.name)"
        >
          <p class="opcao">{{ pause.name }}</p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "getModalPause",
      "getPauses",
      "getId",
      "getPauseTime",
    ]),
  },

  methods: {
    ...mapActions([
      "setModalPause",
      "selectPause",
      "setPauseTime",
      "sendOperatorPauseApi",
    ]),

    btnClose() {
      this.setModalPause();
    },

    clickPause(id, name) {
      console.log("[PAUSE MODAL] clickPause -> id:", id, "name:", name);

      const payload = {
        pauseId: id,
        tempo: moment().format("YYYY-MM-DD HH:mm:ss"),
        queue: user.getQueue(),              // usa fila padrão do usuário
        userId: parseInt(this.getId),
        preserveButton: false,
      };

      console.log("[PAUSE MODAL] payload para Vuex:", payload);

      // 1) zera o timer e avisa o Vuex que começou pausa
      this.setPauseTime(0);

      // 2) envia para API de operador em pausa
      this.sendOperatorPauseApi(payload);

      // 3) marca a pausa no estado (ativa o botão e grava motivo/horário)
      this.selectPause(payload);

      console.log("[PAUSE MODAL] após selectPause:", {
        getPauseTime: this.getPauseTime,
      });

      // 4) fecha o modal
      this.setModalPause();
    },
  },
};
</script>
